import { axios, Response } from '../index'

export interface CreateAdminRequest {
  cpf: string
  accessProfileId: number
}

const createAdmin = (request: CreateAdminRequest): Response<null> => {
  return axios.post(`/v1/admins/`, {
    accessProfileId: request.accessProfileId,
    cpf: request.cpf,
    firstName: 'firstName',
    lastName: 'lastName',
    email: 'email@email.com',
    gender: 'OTHER',
    birthday: '2000-01-01'
  })
}

export default createAdmin
